// export default CreateInvoicePage;
import CreateNewInvoice from "@components/createInvoice";
import React, { useEffect, useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCreateInvoiceMutation } from "store/invoice/invoiceApi";
import { useSelector } from "react-redux";
import { useGetBanksByCompanyQuery } from "store/bank/bank.api";
import AlertMessage from "@components/AlertMessage/AlertMessage";

const CreateInvoicePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const { data: banksData } = useGetBanksByCompanyQuery(user?.companyId?._id, {
    skip: !user?.companyId?._id,
  });
  const [createInvoice] = useCreateInvoiceMutation();
  const [bankList, setBankList] = useState([]);
  console.log("🚀 ~ CreateInvoicePage ~ bankList:", bankList);
  useEffect(() => {
    if (banksData?.data) {
      setBankList(banksData?.data);
    }
  }, [banksData]);

  const handleSaveInvoice = async (invoicePayload) => {
    console.log("🚀 ~ handleSaveInvoice ~ invoicePayload:", invoicePayload);
    try {
      await createInvoice(invoicePayload).unwrap();
      toast.success("Facture brouillon sauvegardée");
      navigate("/invoicesList"); // redirection après succès
    } catch (err) {
      toast.error("Erreur lors de la sauvegarde du brouillon");
      console.error("Erreur:", err);
    }
  };
  return (
    <div className="invoice-layout d-flex p-5" id="invoice-list-page">
      <div className="invoice-create-container">
        <CreateNewInvoice onSave={handleSaveInvoice} />
        {/* Bouton Cancel en bas à droite */}
        <div className="d-flex justify-content-end mt-4">
          <button
            className="btn-secondary"
            onClick={() => navigate("/invoicesList")}
            style={{ minWidth: 120 }}>
            {t("invoice.cancel")}
          </button>
        </div>
      </div>

      {user && bankList.length === 0 && (
        <AlertMessage user={user} isWithBank={bankList?.length !== 0} />
      )}
    </div>
  );
};

export default CreateInvoicePage;
